import { useRef } from 'react';
import styled from 'styled-components';

import { useRouteMatch } from '@treams/treams-routes';
import { Sidebar as Container } from '@treams/treams-ui';

import useAuthenticatedUser from 'packages/kakapo-ui-application/hooks/useAuthenticatedUser';

import GeneralSidebar from './GeneralSidebar';
import HelicopterSidebar from './HelicopterSidebar';
import SettingsSidebar from './SettingsSidebar';
import UserSidebar from './UserSidebar';
import EmployeeSettingsSidebar from './EmployeeSettingsSidebar';
import { useHelicopter } from './HelicopterContext';

const Clip = styled.div`
	overflow: hidden;
`;

function SidebarContents(props: {
	userID?: string;
	settings: boolean;
	employeeSettings: boolean;
	onClose?: () => void;
}) {
	const memory = useRef({ ...props });

	memory.current.userID = props.userID ?? memory.current.userID;

	const helicopter = useHelicopter();

	return (
		<Clip>
			<GeneralSidebar
				visible={!props.userID && !props.settings && !helicopter.enabled}
				onClose={props.onClose}
			/>
			<HelicopterSidebar
				visible={!props.userID && !props.settings && helicopter.enabled}
				onClose={props.onClose}
			/>
			{memory.current.userID && (
				<UserSidebar
					visible={!!props.userID}
					userID={memory.current.userID}
					onClose={props.onClose}
				/>
			)}
			<SettingsSidebar
				visible={props.settings && !props.employeeSettings}
				onClose={props.onClose}
			/>
			<EmployeeSettingsSidebar visible={props.employeeSettings} onClose={props.onClose} />
		</Clip>
	);
}

export default function Sidebar(props: { onClose?: () => void }) {
	const users = useRouteMatch('/users/:id');
	const settings = !!useRouteMatch('/settings');
	const employeeSettings = !!useRouteMatch('/settings/employees');
	const viewer = useAuthenticatedUser();

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const userID = (users?.params as any)?.id;

	return (
		<Container sticky p={0}>
			<SidebarContents
				userID={userID && userID !== viewer.id ? userID : undefined}
				settings={settings}
				employeeSettings={employeeSettings}
				onClose={props.onClose}
			/>
		</Container>
	);
}
